import { render } from "./DeleteAccountWrapper.vue?vue&type=template&id=55ca28b6&scoped=true"
import script from "./DeleteAccountWrapper.vue?vue&type=script&lang=js"
export * from "./DeleteAccountWrapper.vue?vue&type=script&lang=js"

import "./DeleteAccountWrapper.vue?vue&type=style&index=0&id=55ca28b6&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ca28b6"]])

export default __exports__